import { currentLang, currentLocale } from "@/i18n/languages";

export const formatCurrency = (value, currency = "EUR", opts = {}) => {
    if (value == null || isNaN(value)) return "—";
    try {
        return new Intl.NumberFormat(currentLocale(), {
            style: "currency",
            currency,
            maximumFractionDigits: opts.fraction ?? 2,
            minimumFractionDigits: opts.minFraction ?? 0,
        }).format(value);
    } catch {
        return `${value} ${currency}`;
    }
};

export const formatPct = (value, opts = {}) => {
    if (value == null || isNaN(value)) return "—";
    const sign = value > 0 ? "+" : "";
    return `${sign}${Number(value).toFixed(opts.fraction ?? 2)}%`;
};

export const formatNumber = (value, opts = {}) => {
    if (value == null || isNaN(value)) return "—";
    return new Intl.NumberFormat(currentLocale(), {
        maximumFractionDigits: opts.fraction ?? 2,
    }).format(value);
};

const QTY_DECIMALS = { fund: 4, pension: 4, crypto: 8, bond: 2 };

export const formatQuantity = (value, assetType) => {
    if (value == null || isNaN(value)) return "—";
    return new Intl.NumberFormat(currentLocale(), {
        maximumFractionDigits: QTY_DECIMALS[assetType] ?? 2,
    }).format(value);
};

export const formatDate = (value) => {
    if (!value) return "—";
    try {
        const d = new Date(value);
        return d.toLocaleDateString(currentLocale(), { day: "2-digit", month: "short", year: "numeric" });
    } catch {
        return value;
    }
};

// "13 de julio", sin ano. Se parsea a mano en vez de con Date porque una fecha
// YYYY-MM-DD se interpreta como UTC y en Espana se pintaria el dia siguiente.
const _MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

export const formatDayMonth = (isoDate) => {
    if (!isoDate) return "—";
    const [, m, d] = String(isoDate).slice(0, 10).split("-");
    if (currentLang() === "en") {
        if (!(Number(m) >= 1 && Number(m) <= 12) || !d) return isoDate;
        const month = new Intl.DateTimeFormat("en-GB", { month: "long", timeZone: "UTC" }).format(new Date(Date.UTC(2000, Number(m) - 1, 1)));
        return `${Number(d)} ${month}`;
    }
    const mes = _MESES[Number(m) - 1];
    if (!mes || !d) return isoDate;
    return `${Number(d)} de ${mes}`;
};

export const colorForPL = (value) => (value >= 0 ? "text-petrol" : "text-wine");
